import React from 'react';
import '../styles/escaleraInteractiva.css';

export default function EscaleraInteractiva(props) {
    return (
        <div className='escaleraInteractiva__div--container' style={{top: props.top, left: props.left}}>
            <div className='escaleraInteractiva__div--div-imagen'>
                <img className='escaleraInteractiva__img' src={props.imagen} alt={props.alt} style={{width: props.width}}/>
            </div>
        </div>
    )
}
